import {useMutation} from 'react-query';
import {apiService} from '~services/ApiService';

export type SavePyxiSelectQuizAnswerPayload = {
  form_type: string;
  field: string;
  value: string;
};

export type SavePyxiSelectQuizAnswerResponse = {
  success?: boolean;
  message?: string;
  // Allow additional fields without strict typing
  [key: string]: any;
};

export function useSavePyxiSelectQuizAnswer() {
  return useMutation<SavePyxiSelectQuizAnswerResponse, Error, SavePyxiSelectQuizAnswerPayload>(
    async payload => {
      return await apiService.post<SavePyxiSelectQuizAnswerResponse>('pyxi-select/quiz/save', payload);
    }
  );
}

export default useSavePyxiSelectQuizAnswer;
